<!-- eslint-disable max-len -->
<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="header">
        Activate Member
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="title">
        Are you sure you want to activate this member?
      </div>
      <div class="sub-title">
        When active, the member will regain full access to all functionalities and
        features, enabling them to log in and use the platform as usual.
      </div>
      <div>
        <span>Please note</span>: Reactivating a user will restore their previous settings and preferences.
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button-two"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="activateMember"
      >
        Yes
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ActivateMember',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async activateMember() {
      this.processing = true;
      try {
        await this.$store.dispatch('activateCustomer');
        this.toggleActionModal(false);
        this.$store.dispatch('showSuccessToast', {
          header: 'Member activation.',
          message: `${this.customer.firstName} ${this.customer.lastName} was successfully activated`,
        });
        await Promise.all([
          this.$store.dispatch('getAllCustomers'),
          this.$store.dispatch('getPartnerCustomerCount'),
          this.$store.dispatch('getAllDeactivatedCustomers'),
        ]);
      } catch (err) {
        console.error(err);
        this.$store.dispatch('showAlertToast', {
          header: 'There was an unexepected error activating member.',
          message: 'Please try again or contact support',
        });
      }
      this.processing = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  padding-top: 10px;
  font-weight: 600;
}

.header {
  font-size: 1.50rem;
  font-weight: bold;
}

.sub-title {
  padding-top: 20px;
  padding-bottom: 20px;
}

span {
  text-decoration: underline;
}
</style>
